// import React from "react";
// import CounterCard from "../../component/CounterCard";
// import { BsDatabaseCheck, BsPeople } from "react-icons/bs";
// import { PiBriefcaseBold, PiFactoryDuotone } from "react-icons/pi";

// const Counter = ({ statData }) => {
//   return (
//     <div>
//       <section className="bg-white py-12 sm:py-16 px-5 sm:px-20">
//         <p className="text-center text-gray-700 mb-8">
//           Job allowance offers you the sum of ₦5000 - ₦10000 monthly to cover
//           your transportation allowance to potential employers for interview and
//           will be deducted once you get a job.
//         </p>

//         <div className="flex flex-wrap justify-center gap-16 font-semibold text-gray-800">
//           <CounterCard
//             title="ejob users"
//             value={statData?.jobSeeker?.length}
//             Icon={<BsPeople className="w-5 h-5" />}
//           />
//           <CounterCard
//             title="Companies"
//             value={statData?.companies?.length}
//             Icon={<PiFactoryDuotone className="w-5 h-5" />}
//           />
//           <CounterCard
//             title="Applications"
//             value={statData?.applications?.length}
//             Icon={<BsDatabaseCheck className="w-5 h-5" />}
//           />
//           <CounterCard
//             title="Jobs"
//             value={statData?.jobs?.length}
//             Icon={<PiBriefcaseBold className="w-5 h-5" />}
//           />
//         </div>
//       </section>
//     </div>
//   );
// };

// export default Counter;







import React from "react";
import CounterCard from "../../component/CounterCard";
import { BsDatabaseCheck, BsPeople } from "react-icons/bs";
import { PiBriefcaseBold, PiFactoryDuotone } from "react-icons/pi";

const Counter = ({ statData }) => {
  return (
    <div>
      <section className="bg-white py-2 sm:py-2 px-5 sm:px-20">
        <p className="text-center text-gray-700 mb-8">
          Job allowance offers you the sum of ₦5000 - ₦10000 monthly to cover
          your transportation allowance to potential employers for interview and
          will be deducted once you get a job.
        </p>

        <div className="flex flex-row justify-center gap-1 sm:gap-16   sm:flex-wrap font-semibold text-gray-800">
          <CounterCard
            title="ejob users"
            value={statData?.jobSeeker?.length}
            Icon={<BsPeople className="w-5 h-5" />}
            className="w-16 h-16 sm:w-auto sm:h-auto"
          />
          <CounterCard
            title="Companies"
            value={statData?.companies?.length}
            Icon={<PiFactoryDuotone className="w-5 h-5" />}
            className="w-16 h-16 sm:w-auto sm:h-auto"
          />
          <CounterCard
            title="Applications"
            value={statData?.applications?.length}
            Icon={<BsDatabaseCheck className="w-5 h-5" />}
            className="w-16 h-16 sm:w-auto sm:h-auto"
          />
          <CounterCard
            title="Jobs"
            value={statData?.jobs?.length}
            Icon={<PiBriefcaseBold className="w-5 h-5" />}
            className="w-16 h-16 sm:w-auto sm:h-auto"
          />
        </div>
      </section>
    </div>
  );
};

export default Counter;